import 'bootstrap';

var ChartColor = [
  "#5D62B4",
  "#54C3BE",
  "#EF726F",
  "#F9C446",
  "rgb(93.0, 98.0, 180.0)",
  "#21B7EC",
  "#04BCCC",
];
var primaryColor = getComputedStyle(document.body).getPropertyValue(
  "--primary"
);
var secondaryColor = getComputedStyle(document.body).getPropertyValue(
  "--secondary"
);
var successColor = getComputedStyle(document.body).getPropertyValue(
  "--success"
);
var warningColor = getComputedStyle(document.body).getPropertyValue(
  "--warning"
);
var dangerColor = getComputedStyle(document.body).getPropertyValue("--danger");
var infoColor = getComputedStyle(document.body).getPropertyValue("--info");
var darkColor = getComputedStyle(document.body).getPropertyValue("--dark");
var lightColor = getComputedStyle(document.body).getPropertyValue("--light");

// Create a function to contain the initialization code
function initializePage() {
  (function ($) {
    "use strict";
    $(function () {
      var body = $("body");
      var contentWrapper = $(".content-wrapper");
      var scroller = $(".container-scroller");
      var footer = $(".footer");
      var sidebar = $(".sidebar");

      // Function to set active menu based on current path
      function setActiveMenu() {
        const currentPath = window.location.pathname;
        
        // Remove all active states
        $('.nav-link').removeClass('active');
        
        // Set active state for exact match
        $('.nav-link').each(function() {
          const href = $(this).attr('href');
          if (href && href !== '#' && currentPath.includes(href)) {
            $(this).addClass('active');
            
            // If in submenu, expand parent
            const parentCollapse = $(this).closest('.collapse');
            if (parentCollapse.length) {
              const parentCollapseId = parentCollapse.attr('id');
              const parentTrigger = $(`[data-bs-toggle="collapse"][href="#${parentCollapseId}"]`);
              parentCollapse.addClass('show');
              parentTrigger.addClass('active');
              parentTrigger.find('.menu-arrow').addClass('rotate');
            }
          }
        });
      }

      // Handle sidebar toggle
      $('[data-bs-toggle="minimize"]').on('click', function(e) {
        e.preventDefault();
        if ((body.hasClass('sidebar-toggle-display')) || (body.hasClass('sidebar-absolute'))) {
          body.toggleClass('sidebar-hidden');
        } else {
          body.toggleClass('sidebar-icon-only');
        }
      });

      // Handle mobile sidebar toggle
      $('[data-toggle="sidebar"]').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.sidebar').toggleClass('active');
      });

      // Handle collapse events using Bootstrap's events
      document.querySelectorAll('.collapse').forEach(collapseEl => {
        collapseEl.addEventListener('show.bs.collapse', function() {
          // Hide other collapses
          document.querySelectorAll('.collapse.show').forEach(openCollapse => {
            if (openCollapse !== this) {
              const collapseInstance = bootstrap.Collapse.getInstance(openCollapse);
              if (collapseInstance) {
                collapseInstance.hide();
              }
            }
          });
          
          // Rotate arrow
          const trigger = document.querySelector(`[data-bs-toggle="collapse"][href="#${this.id}"]`);
          if (trigger) {
            const arrow = trigger.querySelector('.menu-arrow');
            if (arrow) {
              arrow.classList.add('rotate');
            }
          }
        });

        collapseEl.addEventListener('hide.bs.collapse', function() {
          // Remove arrow rotation
          const trigger = document.querySelector(`[data-bs-toggle="collapse"][href="#${this.id}"]`);
          if (trigger) {
            const arrow = trigger.querySelector('.menu-arrow');
            if (arrow) {
              arrow.classList.remove('rotate');
            }
          }
        });
      });

      // Initialize active menu state
      setActiveMenu();

      //checkbox and radios
      $(".form-check label,.form-radio label").append(
        '<i class="input-helper"></i>'
      );

      //fullscreen
      $("#fullscreen-button").on("click", function toggleFullScreen() {
        if (
          (document.fullScreenElement !== undefined &&
            document.fullScreenElement === null) ||
          (document.msFullscreenElement !== undefined &&
            document.msFullscreenElement === null) ||
          (document.mozFullScreen !== undefined && !document.mozFullScreen) ||
          (document.webkitIsFullScreen !== undefined &&
            !document.webkitIsFullScreen)
        ) {
          if (document.documentElement.requestFullScreen) {
            document.documentElement.requestFullScreen();
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
          } else if (document.documentElement.webkitRequestFullScreen) {
            document.documentElement.webkitRequestFullScreen(
              Element.ALLOW_KEYBOARD_INPUT
            );
          } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen();
          }
        } else {
          if (document.cancelFullScreen) {
            document.cancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
      });
    });
  })(jQuery);
}

// Add styles for menu arrow rotation
const style = document.createElement('style');
style.textContent = `
  .menu-arrow {
    transition: transform 0.3s ease;
  }
  .menu-arrow.rotate {
    transform: rotate(180deg);
  }
  .sidebar-icon-only .sidebar .nav .nav-item .nav-link .menu-arrow {
    display: none;
  }
`;
document.head.appendChild(style);

// Run on both initial page load and Turbo navigation
document.addEventListener("DOMContentLoaded", initializePage);
document.addEventListener("turbo:render", initializePage);
